import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';

// Proto: people.BulkImportSkippedEmail.
export default class BulkImportSkippedEmail extends Fragment {
  declare [Type]: 'people/bulk-import-skipped-email';

  // email is the email address which conflicted.
  @attr('string', { defaultValue: '' })
  declare email: string;

  // name is the name of the existing user with this email address.
  @attr('string', { defaultValue: '' })
  declare name: string;

  // inThisSchool flags whether the existing user is in the same school.
  @attr('boolean', { defaultValue: false })
  declare inThisSchool: boolean;

  // schools is a list of school names which the existing user is linked to.
  @array('string')
  declare schools: StatefulArray<string>;

  // reason is a brief description of why the conflict wasn't resolved.
  @attr('string', { defaultValue: '' })
  declare reason: string;

  // existingPersonId is the unique identifier of the existing Person with
  // the requested email address.
  @attr('string', { defaultValue: '' })
  declare existingPersonId: string;
}
